import { Card } from '@snack-uikit/card';
import { useToggleGroup } from '@snack-uikit/toggles';
import { Tooltip } from '@snack-uikit/tooltip';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function ToggleCard(_ref) {
  var value = _ref.value,
    label = _ref.label,
    description = _ref.description,
    disabled = _ref.disabled,
    disabledReason = _ref.disabledReason,
    dataTestId = _ref.dataTestId;
  var _useToggleGroup = useToggleGroup({
      value: value
    }),
    isChecked = _useToggleGroup.isChecked,
    handleClick = _useToggleGroup.handleClick;
  return /*#__PURE__*/_jsx(Tooltip, {
    open: disabled && disabled ? undefined : false,
    tip: disabledReason,
    children: /*#__PURE__*/_jsx(Card, {
      outline: true,
      checked: isChecked,
      onClick: handleClick,
      className: styles.card,
      disabled: disabled,
      "data-test-id": dataTestId,
      size: "s",
      children: /*#__PURE__*/_jsx(Card.Header, {
        title: label !== null && label !== void 0 ? label : value,
        description: description,
        truncate: {
          title: 10,
          description: 20
        }
      })
    })
  });
}